<template>
  <div>
    <v-data-table
      class="elevation-5"
      no-data-text="Não há registros"
      rows-per-page-text="Linhas por página"
      :headers="headers"
      :items="faturas"
      :loading="isLoading"
      :pagination.sync="pagination"
      :total-items="totalFaturas"
      :rows-per-page-items="pageOptions"
      @update:pagination="gridFaturas"
    >
      <template v-slot:items="props">
        <td>{{ props.item.competencia }}</td>
        <td>{{ props.item.dataVencimento | formatDate }}</td>
        <td>{{ props.item.valorTotal }}</td>
        <td>{{ props.item.valorPago }}</td>
        <td>{{ props.item.saldo }}</td>
        <td>
          <span
            :class="
              props.item.situacao === 'Quitada' ? 'green--text' : 'red--text'
            "
            >{{ props.item.situacao.toUpperCase() }}</span
          >
        </td>
        <td>
          <v-btn
            flat
            small
            color="primary"
            @click="baixarFatura(props.item.downloadId, props.item)"
            >BAIXAR 2ª VIA</v-btn
          >
        </td>
        <td
          v-if="showParcelamento(props.item) || showConsultaBoleto(props.item)"
          class="px-0"
        >
          <v-menu offset-y :nudge-right="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" outline dark v-bind="attrs" v-on="on">
                Ações
                <v-icon color="primary"> expand_more </v-icon>
              </v-btn>
            </template>
            <v-list class="py-0">
              <v-list-tile
                v-for="(action, index) in getActions(props.item)"
                :key="index"
                @click="onClick(action.name, props.item)"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ action.title }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </td>
      </template>
    </v-data-table>
    <div>
      <v-dialog persistent v-model="showModalVencimentoFatura" width="700">
        <v-card>
          <v-card-title primary-title class="headline grey lighten-2">
            Observação sobre vencimendo da fatura
          </v-card-title>
          <v-card-text>
            <p v-html="mensagemVencimentoFatura.mensagem"></p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="geraFaturaVencida">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div>
      <v-dialog persistent v-model="showModalAcaoJudicialFatura" width="700">
        <v-card>
          <v-card-title primary-title class="headline grey lighten-2">
            Atenção:
          </v-card-title>
          <v-card-text>
            <p v-html="mensagemAcaoJudicialFatura"></p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="closeMensagemAcaoJudicialFatura"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <modal-visualizar-parcelamento
      v-bind="{ codigoParcelamento }"
      :show="showModalVisualizarParcelamento"
      :width="`1260`"
      @close="onCloseModal"
    />
    <modal-detalhamento-fatura-renegociada
      :show="consultaRenegociacao"
      :fatura-id="codigoFaturaRenegociacao"
      @close="consultaRenegociacao = false"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import {
  baixarFatura,
  buscaFaturasBeneficiario,
  validaVencimentoFatura,
  getAcaoJudicialFatura,
  buscaParametroValorTipoBooleanAtivo
} from "@/services/beneficiario";
import ModalVisualizarParcelamento from "./parcelar-fatura/modal-visualizar-parcelamento.vue";
import {
  createParcelamentoFatura,
  visualizarParcelamento
} from "@/services/plapiconnect";

import { download } from "@/utils/download";

import ModalDetalhamentoFaturaRenegociada from "@/components/ModalDetalhamentoFaturaRenegociada.vue";

const { mapState } = createNamespacedHelpers("beneficiario");
const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "Faturas",
  components: {
    ModalVisualizarParcelamento,
    ModalDetalhamentoFaturaRenegociada
  },
  data() {
    return {
      faturas: [],
      pageOptions: [5, 10, 25],
      isLoading: false,
      totalFaturas: 0,
      pagination: {
        page: 1,
        rowsPerPage: 5,
        sortBy: "competencia",
        descending: true
      },
      headers: [
        { text: "Competência", value: "competencia" },
        { text: "Vencimento", value: "dataVencimento", sortable: false },
        { text: "Valor", value: "valorTotal", sortable: false },
        { text: "Valor Pago", value: "valorPago", sortable: false },
        { text: "Saldo", value: "saldo", sortable: false },
        { text: "Situação", value: "situacao", sortable: false },
        {
          text: "Fatura",
          value: "downloadId",
          sortable: false,
          align: "center"
        }
      ],
      mensagemAcaoJudicialFatura: null,
      bloqueioAcessoFaturaAcaoJudicial: false,
      mensagemVencimentoFatura: { mensagem: null, processo: null },
      showModalVencimentoFatura: false,
      showModalAcaoJudicialFatura: false,
      okBotaoModalVencimentoFatura: false,
      faturasBloqueio: [],
      actions: [
        {
          title: "Parcelar Fatura",
          name: "parcelar-fatura",
          key: "PARCELAR_FATURA"
        },
        {
          title: "Consultar Boleto",
          key: "CONSULTAR_BOLETO",
          name: "visualizar-boleto"
        },
        {
          title: "Detalhamento da Renegociação",
          key: "DETALHAMENTO_RENEGOCIACAO",
          name: "detalhamento-renegociacao"
        }
      ],
      parametroExibeParcelamento: false,
      showModalVisualizarParcelamento: false,
      codigoParcelamento: null,
      consultaRenegociacao: false,
      codigoFaturaRenegociacao: null
    };
  },
  computed: {
    ...mapState(["dadosBeneficiario"]),
    codigoBeneficiario() {
      return this.dadosBeneficiario.id;
    }
  },
  watch: {
    codigoBeneficiario: {
      async handler() {
        await this.gridFaturas();
      }
    }
  },
  async created() {
    await this.gridFaturas();
    this.parametroExibeParcelamento = await buscaParametroValorTipoBooleanAtivo(
      24
    );
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    closeMensagemVencimentoFatura() {
      this.showModalVencimentoFatura = false;
    },
    closeMensagemAcaoJudicialFatura() {
      this.showModalAcaoJudicialFatura = false;
    },
    async geraFaturaVencida() {
      this.closeMensagemVencimentoFatura();
      this.okBotaoModalVencimentoFatura = true;
      this.showLoading = true;
      await this.baixarFatura(this.mensagemVencimentoFatura.processo);
      this.showLoading = false;
      this.okBotaoModalVencimentoFatura = false;
    },
    async baixarFatura(downloadId, items) {
      this.isLoading = true;
      this.showModalVencimentoFatura = false;
      if (downloadId === null) {
        this.setToast("Fatura indisponível para download");
        this.okBotaoModalVencimentoFatura = false;
        this.isLoading = false;
      } else {
        if (!this.okBotaoModalVencimentoFatura) {
          const mensagemVencimento = await validaVencimentoFatura(items.id);
          if (mensagemVencimento.mensagem) {
            this.isLoading = false;
            this.mensagemVencimentoFatura.mensagem =
              mensagemVencimento.mensagem;
            this.mensagemVencimentoFatura.processo = downloadId;
            this.showModalVencimentoFatura = true;
            return;
          }
        }
        await baixarFatura(downloadId).then(({ headers, data }) => {
          if (data?.error) {
            const errorMessage = data.message;

            this.setErrorToast(errorMessage);
            this.isLoading = false;
          } else {
            const filename = headers["content-disposition"].replace(
              "attachment; filename=",
              ""
            );

            download(data, filename);
            this.isLoading = false;
          }
        });
      }
    },
    async getAcaoJudicialFatura(faturaId) {
      return await getAcaoJudicialFatura(faturaId);
    },
    gridFaturas() {
      this.isLoading = true;

      const { rowsPerPage, descending } = this.pagination;

      const page = this.pagination.page - 1;
      const size = rowsPerPage;
      const sort = `competencia,${
        descending || descending === null ? "desc" : "asc"
      }`;

      return buscaFaturasBeneficiario(this.codigoBeneficiario, page, size, sort)
        .then(({ content, totalElements, data }) => {
          const promiseArray = content.map(row => {
            const temAcaoJudicialPromisse = this.getAcaoJudicialFatura(row.id);

            return temAcaoJudicialPromisse.then(temAcaoJudicial => {
              if (temAcaoJudicial) {
                if (
                  temAcaoJudicial?.mensagem &&
                  this.mensagemAcaoJudicialFatura === null
                ) {
                  this.mensagemAcaoJudicialFatura = temAcaoJudicial?.mensagem;
                  this.showModalAcaoJudicialFatura = true;
                }
                if (temAcaoJudicial?.bloqueio == "true") {
                  const faturaBloqueio = {
                    fatura: row.id,
                    bloqueio: temAcaoJudicial.bloqueio
                  };
                  this.faturasBloqueio.push(faturaBloqueio);
                }
              }
            });
          });

          Promise.all(promiseArray).then(() => {
            if (this.faturasBloqueio.length == 0) {
              this.faturas = content;
              this.totalFaturas = totalElements;
            } else {
              this.faturas = [];
              this.totalFaturas = 0;
              this.isLoading = false;
            }
          });

          if (data?.error) {
            const errorMessage = data.message;

            this.setErrorToast(errorMessage);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async onClick(action, item) {
      if (action === "parcelar-fatura") {
        this.isLoading = true;

        await createParcelamentoFatura(
          { payload: `{"fatura" : "${item.id}"}` },
          this.$store
        );

        this.$router.push({
          name: action
        });

        this.isLoading = false;
      } else if (action === "detalhamento-renegociacao") {
        this.codigoFaturaRenegociacao = item.id;
        this.consultaRenegociacao = true;
      } else {
        this.showModalVisualizarParcelamento = !this
          .showModalVisualizarParcelamento;

        this.codigoParcelamento = item.codigoParcelamento;

        visualizarParcelamento(item.codigoParcelamento, this.$store);
      }
    },
    onCloseModal() {
      this.showModalVisualizarParcelamento = !this
        .showModalVisualizarParcelamento;
    },
    showParcelamento(item) {
      return (
        this.parametroExibeParcelamento &&
        item?.codigoParcelamento == null &&
        item?.situacao !== "Parcelado"
      );
    },
    showConsultaBoleto(item) {
      return item?.codigoParcelamento != null;
    },
    showDetalhamentoRenegociacao(item) {
      return item?.situacao === "Renegociado";
    },
    getActions(item) {
      if (item?.situacao === "Renegociado") {
        return this.actions.filter(
          ({ key }) => key === "DETALHAMENTO_RENEGOCIACAO"
        );
      }
      return this.actions.filter(
        ({ key }) =>
          (key === "PARCELAR_FATURA" && this.showParcelamento(item)) ||
          (key === "CONSULTAR_BOLETO" && this.showConsultaBoleto(item))
      );
    }
  }
};
</script>
